import { Row, Col, Alert } from 'antd';
import { useModal } from '@/hooks';
import { useAnnouncementStore } from '@/store';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@/components/modals';
import { LoadingSpin, PageContainer, TryAgain } from '@/components';
import { sanitizeAnnouncementHtml } from '@/utils/sanitizeAnnouncementHtml';
import AnnouncementItem from './AnnouncementItem';

import './style.css';

const renderAlert = (message: string) => (
  <Alert
    type="warning"
    message={message}
    className="w-full min-h-[50px] text-center" />
);

const AnnouncementsPage = () => {

  const modal = useModal();
  const [fetchAnnouncements, announcements, error, loading] = useAnnouncementStore(s => [s.fetchAnnouncements, s.announcements, s.error, s.loading]);
  const [t] = useTranslation(['common']);

  return (
    <PageContainer title={t('common:labels.announcements')}>
      <SimpleModal
        hide={modal.hide}
        open={modal.open}
        title={modal.data?.title}
        content={sanitizeAnnouncementHtml(modal?.data?.mainText)}
        bodyClassName="rt-rendered-content"
      />
      {loading && <LoadingSpin />}
      {!loading && error && <TryAgain text={t('common:labels.try-again')} onRetry={fetchAnnouncements} />}
      {!loading && !error &&
        <Row>
          <Col span={24}>
            <Row className="app-announcement-list" gutter={[16, 16]}>
              {announcements.length === 0 && renderAlert(t('common:messages.no-items-to-show'))}
              {announcements.map((item, key) => (
                <Col className="announcement-item-container" key={key} span={24}>
                  <AnnouncementItem
                    {...item}
                    onClick={() => modal.show(item)}
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      }
    </PageContainer >
  );

};

export default AnnouncementsPage;
